<template>
  <div class="cifra-input-iban">
    <div class="form-group">
      <label class=" control-label" for="cifra_input_iban_iban">
        IBAN
      </label>
      <input
        type="text"
        class="form-control iban"
        :name="name('iban')"
        :disabled="disabled"
        :value="ibanInterno"
        @input="cambiaCampo('iban', $event.target.value)"
      />
    </div>
    <div v-show="mostrarBic" class="form-group">
      <label class=" control-label" for="cifra_input_iban_iban">
        BIC/SWIFT
      </label>
      <input
        type="text"
        class="form-control bic"
        :name="name('bic')"
        :disabled="disabled"
        :value="bicInterno"
        @input="cambiaCampo('bic', $event.target.value)"
      />
    </div>
  </div>
</template>

<script>
import { isEmpty } from 'lodash';
/*
Este componente tiene el input para el IBAN pero detecta si es extranjero
o español y muestra el campo para introducir el BIC/SWIFT
OJO!!!! No funciona con v-model, simplemente mantiene el valor en los inputs
del formulario. Cuando lo pasemos a Vue 3 ya podríamos hacerlo mejor
 */
export default {
  props: {
    namespace: { type: String, default: '' },
    iban: { type: String, default: '' },
    bic: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      ibanInterno: this.iban,
      bicInterno: this.bic,
    };
  },
  computed: {
    mostrarBic() {
      return this.ibanInterno.length > 2 && !this.ibanInterno.startsWith('ES');
    },
  },
  watch: {
    mostrarBic(valor) {
      if (!valor) {
        this.bicInterno = '';
      }
    },
  },
  methods: {
    name(campo) {
      if (isEmpty(this.namespace)) {
        return campo;
      }
      return `${this.namespace}[${campo}]`;
    },
    cambiaCampo(nombre, valor) {
      this[`${nombre}Interno`] = valor.toUpperCase().replace(/\s/g, '');
      // this.$set(this, `${nombre}Interno`, valor.toUpperCase().replace(/\s/g, ''));
    },
  },
};
</script>
